<template>
    <div>
        <div class="text-center secondary-color">
            <img :src="unhappyIcon" alt="error404" height="150px" class="mb-4">
            <div class="mb-4">
                <h1 class="display-2">404</h1>
            </div>
            <h3>Page Not Found</h3>
            <p>The page you are looking for doesn't exist or an error occured.</p>
        </div>
    </div>
</template>

<script>
    let unhappyIcon = require('@/assets/icons/unhappy.svg');
    export default {
        name: 'Error404',
        data() {
            return {
                unhappyIcon: unhappyIcon
            }
        }
    }
</script>



// WEBPACK FOOTER //
// src/components/Error404.vue